import { render, staticRenderFns } from "./MotoboyAdd.vue?vue&type=template&id=dd312738"
import script from "./MotoboyAdd.vue?vue&type=script&lang=js"
export * from "./MotoboyAdd.vue?vue&type=script&lang=js"
import style0 from "./MotoboyAdd.vue?vue&type=style&index=0&id=dd312738&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports